import React from 'react'
import { Box } from './'

const Counter = (props) => (
  <Box
    group='a'
    className={`gp-counter ${props.className}`}
    style={props.style}
  >
    {props.value}
  </Box>
)

Counter.defaultProps = {
  className: '',
  style: {}
}

export default Counter
